import axios from 'axios';
import { IIndex, IIndexColumn, IUserV2 } from '../../types';

interface IParams {
  type: 'users';
  page?: number;
  pageSize?: number;
  context: {
    apiUrl: string;
    user: IUserV2;
  };
}

/**
 * Get index of system forms data from the server
 *
 * @param {string} type right now it can only be 'users'
 * @param {number} page number of the page to be fetched
 * @param {number} pageSize number of items per page
 * @returns
 */
async function getSystemIndex({ type, page, pageSize, context }: IParams) {
  const { apiUrl, user } = context;

  if (user.credentials) {
    if (type === 'users') {
      const credentials: any = user.credentials;
      let url = `${apiUrl}/main_api/v1/users/`;

      try {
        const response = await axios.post(
          url,
          {
            page,
            pageSize,
          },
          {
            headers: {
              ...credentials,
            },
          }
        );

        if (response.status === 200) {
          const { users } = response.data;
          const total = +response.headers['x-total'];
          const pageFromServer = +response.headers['x-page'];
          const pageSizeFromServer = +response.headers['x-per-page'];

          const columns: IIndexColumn[] = [
            {
              fid: 'username',
              label: 'Username',
              path: 'username',
            },
          ];
          const index: IIndex = {
            fid: 'users',
            pagination: {
              page: pageFromServer,
              pageSize: pageSizeFromServer,
              total,
            },
            types: {
              table: true,
              map: true,
            },
            columns,
            rows: users.map((user: any) => ({
              ...user,
              // We're adding this answers property because on the UI layer, when the row
              // has the answers property, it won't be clickable. It works like that because
              // when a row has answers, it means it's a register's answer column.
              answers: {},
            })),
          };

          return index;
        }
      } catch (e) {
        console.log('getSystemIndex->e: ', e);
      }
    }
  }

  return undefined;
}

export default getSystemIndex;
